import React from 'react';
import useDialog from '../hooks/useDialog';

const ImageModal = ({ imageUrl, altText, onClose }) => {
  const dialogRef = useDialog(onClose);

  if (!imageUrl) return null;

  return (
    <div
      ref={dialogRef}
      role="dialog"
      aria-modal="true"
      aria-label={altText || 'Enlarged photo'}
      tabIndex={-1}
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
      }}
      onClick={onClose}
    >
      <button
        onClick={onClose}
        aria-label="Close photo"
        className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gold transition z-10"
        style={{ width: '50px', height: '50px' }}
      >
        <span aria-hidden="true">×</span>
      </button>
      <img
        src={imageUrl}
        alt={altText}
        className="max-w-full max-h-full object-contain"
        style={{ maxHeight: '90vh', maxWidth: '90vw' }}
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}

export default ImageModal;
